"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPaymentMethodId = void 0;
var getPaymentMethodId = exports.getPaymentMethodId = function getPaymentMethodId(source, type) {
  if (type) {
    return "".concat(source, "|").concat(type);
  }
  return source;
};